import { GetFormDocument, GetFormQuery, GetFormQueryVariables, Scalars } from 'generated/graphql';
import { client } from './client';
import { getLocalesForGraphQL } from '../utils/helpers';

export async function getForm(id: string, locale: string) {
  return client.query<GetFormQuery, GetFormQueryVariables>({
    query: GetFormDocument,
    variables: {
      locales: getLocalesForGraphQL(locale),
      where: {
        id,
      },
    },
  });
}
